export default __webpack_public_path__ + "static/media/370.8dd4f3d0.png";